(function () {
  'use strict';

  var KEY = 'cardim_wishlist';
  var SYNC_KEY = 'cardim_wishlist_synced'; // flag: localStorage merged into server

  var SVG_EMPTY = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  var SVG_FILLED = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="color:#c0392b"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  // In-memory list — always the source of truth after init
  var _list = [];
  var _ready = false;

  // ── localStorage helpers ──────────────────────────────────
  function lsGet() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function lsSave(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  // ── Core wishlist API ─────────────────────────────────────
  function get() { return _list.slice(); }

  function has(id) {
    return _list.some(function (p) { return String(p.id) === String(id); });
  }

  function toggle(product) {
    var found = -1;
    for (var i = 0; i < _list.length; i++) {
      if (String(_list[i].id) === String(product.id)) { found = i; break; }
    }
    if (found === -1) { _list.push(product); }
    else { _list.splice(found, 1); }
    _persist();
    return found === -1; // true = added
  }

  function remove(id) {
    _list = _list.filter(function (p) { return String(p.id) !== String(id); });
    _persist();
  }

  // ── Persist: always write localStorage + server if logged in ──
  function _persist() {
    lsSave(_list);
    if (window.__cardimCustomerLoggedIn) {
      _serverSave(_list);
    }
    syncButtons();
    syncCounter();
    window.dispatchEvent(new CustomEvent('cardim:wishlist', { detail: { list: get() } }));
  }

  // ── Server API ────────────────────────────────────────────
  var API_URL = window.__cardimWishlistApiUrl || '';

  function _serverLoad(callback) {
    var cid = window.__cardimCustomerId;
    var tok = window.__cardimWishlistToken;
    if (!cid || !tok || !API_URL) return callback(lsGet(), false);
    fetch(API_URL + '/api/wishlist?cid=' + encodeURIComponent(cid) + '&tok=' + encodeURIComponent(tok))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.error) { callback(lsGet(), false); return; }
        callback(Array.isArray(d.list) ? d.list : [], true);
      })
      .catch(function () { callback(lsGet(), false); });
  }

  function _serverSave(list) {
    var cid = window.__cardimCustomerId;
    var tok = window.__cardimWishlistToken;
    if (!cid || !tok || !API_URL) return;
    fetch(API_URL + '/api/wishlist', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cid: cid, tok: tok, list: list }),
    }).catch(function () {});
  }

  // ── Merge: localStorage items that aren't in server list ─
  function _mergeLocalIntoServer(serverList) {
    var local = lsGet();
    if (!local.length) return serverList;
    var merged = serverList.slice();
    local.forEach(function (item) {
      var already = merged.some(function (p) { return String(p.id) === String(item.id); });
      if (!already) merged.push(item);
    });
    return merged;
  }

  // ── UI helpers ────────────────────────────────────────────
  function syncButtons() {
    document.querySelectorAll('.cc-wish-btn').forEach(function (btn) {
      var active = has(btn.dataset.productId);
      btn.classList.toggle('cc-wish-btn--active', active);
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      var heart = btn.querySelector('.cc-wish-heart');
      if (heart) heart.innerHTML = active ? SVG_FILLED : SVG_EMPTY;
    });
  }

  function syncCounter() {
    var n = _list.length;
    document.querySelectorAll('.cc-wish-count').forEach(function (el) {
      el.textContent = n || '';
      el.style.display = n ? '' : 'none';
    });
  }

  function showToast() {
    var el = document.getElementById('cc-wish-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'cc-wish-toast';
      el.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style="width:16px;height:16px;flex-shrink:0;color:#e8896a"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
        '<span id="cc-wish-toast-text">Sign in to save your wishlist</span>' +
        '<a href="/account/login" id="cc-wish-toast-link">Sign in &rarr;</a>' +
        '<button id="cc-wish-toast-close" aria-label="Close">&times;</button>';
      document.body.appendChild(el);
      document.getElementById('cc-wish-toast-close').addEventListener('click', function () {
        el.classList.remove('cc-wish-toast--show');
        clearTimeout(el._t);
      });
    }
    el.classList.add('cc-wish-toast--show');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('cc-wish-toast--show'); }, 6000);
  }

  // ── Header injection ──────────────────────────────────────
  function injectHeaderIcon() {
    if (document.querySelector('.cc-wish-header')) return;
    var headerActions = document.querySelector('.cardim-header__actions');
    if (!headerActions) return;
    var link = document.createElement('a');
    link.href = '/pages/wishlist';
    link.className = 'cardim-header__action cc-wish-header';
    link.setAttribute('aria-label', 'Wishlist');
    link.innerHTML =
      '<span class="cc-wish-icon">' +
      SVG_EMPTY +
      '<span class="cc-wish-count" style="display:none"></span>' +
      '</span>';
    var cartLink = headerActions.querySelector('.cardim-header__cart');
    headerActions.insertBefore(link, cartLink || headerActions.firstElementChild);
  }

  function injectCSS() {
    if (document.getElementById('cc-wish-styles')) return;
    var style = document.createElement('style');
    style.id = 'cc-wish-styles';
    style.textContent = [
      '.cc-wish-header{position:relative;display:flex;align-items:center;justify-content:center;min-width:44px;height:44px;color:inherit;transition:color 0.2s;text-decoration:none;}',
      '.cc-wish-icon{position:relative;display:flex;align-items:center;}',
      '.cc-wish-icon svg{width:22px;height:22px;display:block;}',
      '.cc-wish-count{position:absolute;top:-5px;right:-8px;background:#c0392b;color:#fff;font-size:10px;font-weight:700;border-radius:50%;min-width:16px;height:16px;line-height:16px;text-align:center;padding:0 3px;}',
      '.cc-wish-btn{position:absolute;top:10px;right:10px;background:rgba(255,255,255,0.92);border:none;border-radius:50%;width:36px;height:36px;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.18);z-index:2;opacity:0;transform:scale(.8);transition:opacity .2s ease,transform .2s ease;padding:0;}',
      '.cc-card:hover .cc-wish-btn,.cc-wish-btn--active{opacity:1;transform:scale(1);}',
      '.cc-wish-btn:hover{background:#fff;transform:scale(1.1);}',
      '.cc-wish-heart{display:flex;align-items:center;justify-content:center;}',
      '.cc-wish-heart svg{width:18px;height:18px;display:block;}',
      '#cc-wish-toast{position:fixed;top:calc(var(--header-group-height,80px) + 12px);left:50%;transform:translateX(-50%) translateY(-20px);background:#1f3d2e;color:#fff;padding:14px 16px 14px 18px;border-radius:14px;font-size:14px;opacity:0;pointer-events:none;transition:opacity .35s,transform .35s;z-index:9999;max-width:calc(100vw - 40px);display:flex;align-items:center;gap:10px;box-shadow:0 6px 24px rgba(0,0,0,0.22);white-space:nowrap;}',
      '#cc-wish-toast.cc-wish-toast--show{opacity:1;pointer-events:auto;transform:translateX(-50%) translateY(0);}',
      '#cc-wish-toast-text{flex:1;font-size:13px;line-height:1.3;}',
      '#cc-wish-toast-link{color:#f0b97a;font-weight:600;text-decoration:none;font-size:13px;white-space:nowrap;border-bottom:1px solid rgba(240,185,122,0.4);padding-bottom:1px;}',
      '#cc-wish-toast-link:hover{color:#f5c990;}',
      '#cc-wish-toast-close{background:none;border:none;color:rgba(255,255,255,0.5);font-size:18px;line-height:1;cursor:pointer;padding:0 0 0 4px;margin-left:2px;flex-shrink:0;}'
    ].join('');
    document.head.appendChild(style);
  }

  // ── Initialise ────────────────────────────────────────────
  window.CardimWishlist = { get: get, has: has, remove: remove };

  function _startUI() {
    injectCSS();
    injectHeaderIcon();
    syncButtons();
    syncCounter();
    _ready = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cc-wish-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var p = {
        id: String(btn.dataset.productId),
        handle: btn.dataset.productHandle || '',
        title: btn.dataset.productTitle || '',
        price: btn.dataset.productPrice || '',
        image: btn.dataset.productImage || '',
        url: btn.dataset.productUrl || '',
      };
      var added = toggle(p);
      if (added && !window.__cardimCustomerLoggedIn) {
        showToast();
      }
    });

    window.addEventListener('storage', function (e) {
      if (e.key !== KEY || window.__cardimCustomerLoggedIn) return;
      _list = lsGet();
      syncButtons();
      syncCounter();
      window.dispatchEvent(new CustomEvent('cardim:wishlist', { detail: { list: get() } }));
    });
  }

  function init() {
    if (window.__cardimCustomerLoggedIn) {
      // Load from server, merge any guest localStorage items, then start UI
      _serverLoad(function (serverList, success) {
        if (!success) {
          // Server failed — keep localStorage as-is, don't overwrite
          _list = serverList;
          _startUI();
          return;
        }
        var alreadySynced = localStorage.getItem(SYNC_KEY) === window.__cardimCustomerId;
        if (!alreadySynced) {
          // First login after being a guest — merge localStorage into server
          serverList = _mergeLocalIntoServer(serverList);
          if (serverList.length) _serverSave(serverList);
          try { localStorage.setItem(SYNC_KEY, window.__cardimCustomerId); } catch (e) {}
        }
        _list = serverList;
        lsSave(_list);
        _startUI();
      });
    } else {
      _list = lsGet();
      _startUI();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
